import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {

  static targets = [
    'animate'
  ]

  connect() {
    this.cleanup = this.cleanup.bind(this)
    this.initializeAnimations()
    this.addEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  initializeAnimations() {

    document.fonts.ready.then(() => {
      this.animateTargets.forEach((target) => {
        switch (target.dataset.effect) {
          case "heading": 
            this.animateHeading(target)
            break
          default:
            this.animateSlide(target)
        }
      })
    })
  }

  addEventListeners() {
    document.addEventListener('turbo:before-cache', this.cleanup)
  }

  removeEventListeners() {
    document.removeEventListener('turbo:before-cache', this.cleanup)
  }

  cleanup() {
    this.animateTargets.forEach((target) => {
      target.style.visibility = "hidden"
    })
  }

  animateHeading(target) {
    gsap.from(target, {
      // scale: 1.1,
      opacity: 0,
      filter: "blur(6px)",
      x: 40,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: target,
        start: "top 80%",     // when element top hits 80% of viewport
        end: "top 20%",       // (not crucial without scrub)
        toggleActions: "play none none none"
      }
    })
  }

  animateSlide(target) {
    gsap.from(target,
      {
        x: 40,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: target,
          start: "top 90%",     // when element top hits 80% of viewport
          end: "top 20%",       // (not crucial without scrub)
          toggleActions: "play none none none"
        }
      }
    )

  }

}